import React, { useState, useEffect, useCallback } from "react";
import { GoogleMap, useJsApiLoader, Marker } from "@react-google-maps/api";
import MainService from "../../common/MainService";

// Define the container style for the Google Map
const containerStyle = {
  width: "100vw", // Full width of the viewport
  height: "100vh", // Full height of the viewport
};

// Set the initial center position for the map
const center = {
  lat: 28.6448, // Latitude of the center
  lng: 77.216721, // Longitude of the center
};

function ProcessingUnitLocator() {
  // State to store the list of users of type "FOOD-PROCESSOR"
  const [users, setUsers] = useState([]);
  
  // State to store the location markers for all users
  const [locationMarker, setLocationMarker] = useState([]);

  // Function to fetch all users of the "FOOD-PROCESSOR" user type
  const getAlluserType = () => {
    MainService.getAllUserofUserType("FOOD-PROCESSOR").then((res) => {
      const allusers = res.users.map((e) => e.username); // Extract usernames from the response
      setUsers(allusers); // Update the users state
    });
  };

  // Function to get the locations of all users
  const getStoreLocation = useCallback(() => {
    if (!Array.isArray(users) || users.length === 0) {
      return []; // No users, return empty array
    }
    // Create an array of promises to fetch location data for each user
    const allLocationPromises = users.map((username) =>
      MainService.locationProvider(username, "plant").then((res) => res)
    );
    return allLocationPromises;
  }, [users]); // Dependency on 'users' state to re-fetch locations when users change

  // Fetch users and locations when the component mounts
  useEffect(() => {
    getAlluserType();
  }, []); // Empty dependency array ensures this runs only once

  // Fetch the locations when users are available
  useEffect(() => {
    if (users.length > 0) {
      Promise.all(getStoreLocation()) // Wait for all location promises to resolve
        .then((res) => {
          // Flatten the array and set the location markers state
          const locations = res.flatMap((locationData) => locationData.sites);
          setLocationMarker(locations); // Update location markers
        })
        .catch((err) => {
          console.error("Error occurred:", err); // Log any errors
        });
    }
  }, [users, getStoreLocation]); // Dependency on 'users' and 'getStoreLocation' to trigger location fetching

  // Load the Google Maps API using the useJsApiLoader hook
  const { isLoaded } = useJsApiLoader({
    id: "google-map-script", // Script ID
    googleMapsApiKey: "AIzaSyA08TJWvLGvDD4cXLo-231gioXgaugKUw0", // Google Maps API Key
  });

  // Render the Google Map once it's loaded
  return isLoaded ? (
    <GoogleMap mapContainerStyle={containerStyle} center={center} zoom={4}>
      {/* Render markers for each location */}
      {locationMarker
        .flat() // Flatten the array of arrays into one array of marker objects
        .map((marker, index) => (
          <Marker
            key={index} // Key for each marker to optimize rendering
            name={marker.sitename} // Name of the site
            position={{
              lat: parseFloat(marker.latitude), // Convert latitude to float
              lng: parseFloat(marker.longitude), // Convert longitude to float
            }}
            title={marker.sitename} // Tooltip text for the marker
          />
        ))}
    </GoogleMap>
  ) : (
    // Return empty fragment if the map isn't loaded
    <></>
  );
}

// Export the component wrapped in React.memo to optimize re-renders
export default React.memo(ProcessingUnitLocator);
